<template>
  <div class="network" :class="{'network--active': isActive}">
    <span class="network__title" @click="toggle">Our Network <i class="i-triangle" :class="{'i-triangle--up': isActive}"></i></span>
    <div class="network__list">
      <a :href="item.link" :title="item.title" class="network__link" v-for="(item,key,index) in $root.config.network.sites" :key="index">{{key}}</a>
    </div>
  </div>
</template>


<style lang="scss">
.network {
  display: inline-flex;
  flex-direction: column;
  position: relative;
  margin-top: 15px;
  &__title {
    color: rgba(255, 255, 255, 0.95);
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    .i-triangle {
      margin-left: 5px;
    }
  }
  &__list {
    margin-top: 10px;
    display: none;
	  flex-direction: column;
  }
  &--active &__list {
    display: flex;
  }
  &__link {
    color: $color-link;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}
</style>


<script>
export default {
  data: () => ({
    isActive: false
  }),
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
  },
  created() {
    document.addEventListener('click', (e) => {
       if(!e.target.closest('.network')) {
        this.isActive = false
      }
    });
  }

}
</script>